import React, { useState } from 'react'
import { Switch } from 'antd'
import styled from 'styled-components'
import {
  getAdminSettings,
  setAdminSettings,
} from 'enrollment-platform/utils/adminSettings'

const Section = styled.div`
  margin-bottom: 32px;
`

const SectionTitle = styled.div`
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
`

const SettingRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  padding: 12px 0;
`

const SettingInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

const SettingLabel = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #111827;
`

const SettingDescription = styled.div`
  font-size: 13px;
  color: #6b7280;
  max-width: 480px;
`

export default function TestModeSettings() {
  const [showTestData, setShowTestData] = useState(
    () => getAdminSettings().finance.showTestData
  )

  const handleChange = (value: boolean) => {
    setAdminSettings({ finance: { showTestData: value } })
    setShowTestData(value)
  }

  return (
    <div style={{ maxWidth: 640, padding: '24px 0' }}>
      <Section>
        <SectionTitle>Finance</SectionTitle>
        <SettingRow>
          <SettingInfo>
            <SettingLabel>Show Test Data</SettingLabel>
            <SettingDescription>
              When off, test companies and their associated data are hidden
              across billing profiles, invoice upload, and funding invoice
              pages.
            </SettingDescription>
          </SettingInfo>
          <Switch
            checked={showTestData}
            onChange={handleChange}
            aria-label="Show test data"
          />
        </SettingRow>
      </Section>
    </div>
  )
}
